import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { TextFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkTextPOSTErrorResponse, ParkTextPOSTRequest, ParkTextPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const sendByText = async (requestData: ParkTextPOSTRequest): Promise<ParkTextPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkTextPOSTSuccessResponse>("/text", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkTextPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: TextFailReason };
  }
};
